import { createFetch } from "@vueuse/core";
import { useFailMsgBox } from "@/hooks/common/msg-box/useFailMsgBox";
import { envConfigMap } from "./config";
import useBaseData from "@/hooks/api/useBaseData";
import { useDeleteLoginStorage, useGetB2bLoginURL } from "@/hooks/shopify-hooks/useShopifyMessageEvent";
import { _CSR_IS_B2b } from '@/const/shopifyConst';
import { useGetStorage,useSetStorage } from '@/hooks/common/useStorage';
import {  _CSR_ACCESS_TOKEN } from '@/const/shopifyConst';
  let accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
  const { RUNTIME_ENV } = process.env;
  import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
  import { attemptAccessTokenExchangeRefToken} from '@/hooks/shopify-hooks/useShopifyUtils';

const { gwsPath, scrmPathMap, idcpPath, mcPathMap} = envConfigMap[RUNTIME_ENV];
let { aemPath } = envConfigMap[RUNTIME_ENV];
// 本地环境，加入前缀，方便mock
if (RUNTIME_ENV === 'LOCAL' && aemPath.indexOf(':8080') === -1) {
  aemPath = 'https://localhost:8080' + aemPath;
}
const { ibosDataCenter } = useBaseData();
// const site = document.body.dataset.site;
// let baseUrl = null;
// if (sitesForScrmUsDataCenter.includes(site)) {
//   baseUrl = scrmPathMap.us;
// }
// if (sitesForScrmEuDataCenter.includes(site)) {
//   baseUrl = scrmPathMap.eu;
// }
// if (!baseUrl) {
//   baseUrl = scrmPathMap.hk;
// }
let scrmBaseUrl = null;
console.log('--ibosDataCenter--1', ibosDataCenter);
if (ibosDataCenter === 'US') {
  scrmBaseUrl = scrmPathMap.us;
}
if (ibosDataCenter === 'EU') {
  scrmBaseUrl = scrmPathMap.eu;
}
if (!scrmBaseUrl) {
  scrmBaseUrl = scrmPathMap.hk;
}

export const useScrmFetch = (url,customOptions={})=>{
  return createFetch({
    baseUrl: scrmBaseUrl,
    combination: "overwrite",
    options: {
      // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
      afterFetch(ctx) {
        const { resultCode, resultMsg } = ctx.data;
        if (resultCode === "ISC-000") {
          return ctx.data;
        } else if (resultCode === "EDM-900" && customOptions.formCaptchaFailHint){ // 极验提示错误（为了兼容i18n）
          throw (new Error(customOptions.formCaptchaFailHint));
        } else {
          // notify me接口报错，不弹出错误窗口
          if (resultCode === "EDM-803") {
            return {
              data: {
                value: resultCode
              }
            };
          }
          if (
            typeof resultMsg === "string" &&
            !resultMsg.includes("errorMsg")
          ) {
            // useFailMsgBox(resultMsg);
            throw (new Error(resultMsg));
          } else {
            const iscError = JSON.parse(resultMsg);
            // useFailMsgBox(iscError.errorMsg);
            throw (new Error(iscError.errorMsg));
          }
        }
      },
    },
    fetchOptions: {
      mode: 'cors',
    },
  })(url);
} 

export const useScrmShopifyFetch = createFetch({
  baseUrl: scrmBaseUrl,
  combination: "overwrite",
  options: {
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    afterFetch(ctx) {
      const { resultCode, resultMsg } = ctx.data;
      console.log('==shopify srcm返回---', resultCode, resultMsg)
      if (resultCode === "ISC-000") {
        return ctx.data;
      } else {
        // multipass接口报错，不弹出错误窗口
        if (resultCode === "ISC-924") {
          return {
            data: {
              value: resultCode
            }
          };
        }
        if (resultCode === "ISC-948") {
          // B端用户token失效，跳去B端登录页
          if (useGetStorage(_CSR_IS_B2b)) {
            useGetB2bLoginURL('_self', true);
          } else {
            // c端用户则删除本地存储的token, 且跳去登录页 
            // useDeleteLoginStorage(true);
          }
          return;
        }
        if (
          typeof resultMsg === "string" &&
          !resultMsg.includes("errorMsg")
        ) {
          useFailMsgBox(resultMsg);
          throw (new Error(resultMsg));
        } else {
          const iscError = JSON.parse(resultMsg);
          // 若报错码为Invalid access token，则删除本地存储的token, 且跳去登录页
          if (iscError.errorMsg === 'Invalid access token') {
            useDeleteLoginStorage(true);
          } else {
            useFailMsgBox(iscError.errorMsg);
            throw (new Error(iscError.errorMsg));
          }

        }
      }
    },
  },
  fetchOptions: {
    mode: 'cors',
  },
});

export const useGwsFetch = (url, config = {}) => {
  const { showErrorTips = true } = config;
  return createFetch({
    baseUrl: gwsPath,
    combination: "overwrite",
    options: {
      afterFetch(ctx) {
        const { resultCode, resultMsg } = ctx.data;
        if (resultCode === "ISC-000") {
          return ctx.data;
        } else {
          // 不显示错误提示时，把完整响应体序列化成 error message 抛出
          // 调用方通过 error.value 拿到 JSON 字符串后自行 JSON.parse 判断错误码
          if (!showErrorTips) {
            throw (new Error(JSON.stringify(ctx.data)));
          }
          if (
            typeof resultMsg === "string" &&
            !resultMsg.includes("errorMsg")
          ) {
            useFailMsgBox(resultMsg);
            throw (new Error(resultMsg));
          } else {
            const iscError = JSON.parse(resultMsg);
            useFailMsgBox(iscError.errorMsg);
            throw (new Error(iscError.errorMsg));
          }
        }
      },
    },
    fetchOptions: {
      mode: 'cors',
    },
  })(url);
};

// 解析 useFetch 的 error（showErrorTips: false 时抛出的是响应体的 JSON 字符串）
// 解析失败（如网络错误、非 JSON 文案）时返回空对象，避免调用方报错
export const parseFetchErrorBody = (error) => {
  if (!error) {
    return {};
  }
  try {
    const body = JSON.parse(error);
    return body && typeof body === 'object' ? body : {};
  } catch (e) {
    return {};
  }
};

export const useCustomerApiFetch = (query,variables ={}) =>{
  console.log('accessToken.accessToken',accessToken)
  accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
  const { storeId, ApiVersion } = shopifyConst;

  return fetch(`https://shopify.com/${storeId}/account/customer/api/${ApiVersion}/graphql`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': accessToken.accessToken
    },
        body: JSON.stringify({
            query: query,
            variables
        })
    })
    .then(response => {
      
  
      return response.json();
  })
    .then(async res => {
      console.log('请求res',res)
      if(res?.errors?.length) {
        const exchangeTokenResp = await attemptAccessTokenExchangeRefToken();
        console.log('exchangeTokenResp',exchangeTokenResp)
        if (exchangeTokenResp && exchangeTokenResp.access_token) {
          const finalToken = {
            accessToken: exchangeTokenResp.access_token,
            expiresAt: exchangeTokenResp.expires_in
          };
          useSetStorage(_CSR_ACCESS_TOKEN, finalToken);
          return await useCustomerApiFetch(query, variables);
        } else {
          useGetB2bLoginURL('_self', true);

        }
      } 
      return res
    })
    .catch(error => {
      console.log(error)
    });
}

export const useAEMFetch = createFetch({
  baseUrl: aemPath,
  combination: "overwrite",
  options: {
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    beforeFetch(ctx) {
      // 判断是不是local，如果是，则把localhost的请求替换成base_url，因为workspace跟本地vscode的base url不一样
      if(ctx.url.includes('localhost') && RUNTIME_ENV === 'LOCAL'){
        ctx.url = ctx.url.replace("https://localhost:8080/", process.env.BASE_URL);
      }
      if (ctx && ctx.options && ctx.options.body && ctx.options.body instanceof FormData) {
        // ctx.processData = false;
        // ctx.contentType = false;
        ctx.options.headers = {
          ...ctx.options.headers,
          // "Content-Type": undefined,
          "CSRF-Token": ctx.options.body.get("token"),
        }
      }
    },
    async afterFetch(ctx) {
      const { code, msg } = ctx.data;
      if (code === 200) {
        return ctx.data;
      } else {
        if (
          typeof msg === "string" &&
          !msg.includes("errorMsg")
        ) {
          useFailMsgBox(msg);
          throw (new Error(msg));
        } else {
        }
      }
    },
  },
  fetchOptions: {
    mode: 'cors',
  },
});

export const useOriginalAEMFetch = createFetch({
  baseUrl: aemPath,
  combination: "overwrite",
  options: {
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    afterFetch(ctx) {
      return ctx;
    },
  },
  fetchOptions: {
    mode: 'cors',
  },
});

// 封装idcp接口请求
export const useIdcpFetch = createFetch({
  baseUrl: idcpPath,
  combination: "overwrite",
  options: {
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    afterFetch(ctx) {
      console.log('===idcpFetch===', ctx)
      const { code, resultMsg } = ctx.data;
      if (code === 0) {
        return ctx.data;
      } else {
        if (
          typeof resultMsg === "string" &&
          !resultMsg.includes("errorMsg")
        ) {
          useFailMsgBox(resultMsg);
          throw (new Error(resultMsg));
        } else {
          const iscError = JSON.parse(resultMsg);
          useFailMsgBox(iscError.errorMsg);
          throw (new Error(iscError.errorMsg));
        }
      }
    },
  },
  fetchOptions: {
    mode: 'cors',
  },
});

// 封装德国4a登陆mc接口
let mcBaseUrl = null;

if (ibosDataCenter === 'US') {
  mcBaseUrl = mcPathMap.us;
}
if (ibosDataCenter === 'EU') {
  mcBaseUrl = mcPathMap.eu;
}
if (!mcBaseUrl) {
  mcBaseUrl = mcPathMap.eu;
}

export const useMcFetch = createFetch({
  baseUrl: mcBaseUrl,
  combination: "overwrite",
  options: {
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    afterFetch(ctx) {
      let data = ctx.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          console.error('JSON 解析失败，使用空对象', e);
          data = {};
        }
      } else if (typeof data !== 'object' || data === null) {
        data = {};
      }
      const { resultCode = "UNKNOWN_CODE", resultMsg = "{\"errorCode\":\"UNKNOWN_CODE\"}" } = data;

      console.log({ resultCode, resultMsg }, "6666");
      if (resultCode === "ISC-000") {
        return ctx.data;
      }
      else {
        console.log({ resultCode, resultMsg }, "666677");
        if (
          typeof resultMsg === "string" &&
          !resultMsg.includes("errorCode")
        ) {
          throw (new Error(resultMsg));
        } else {
          const iscError = JSON.parse(resultMsg);
          throw (new Error(iscError.errorCode));
        }
      }
    },
  },
  fetchOptions: {
    mode: 'cors',
  },
});

export const useOtherFetch = createFetch({
  baseUrl: 'https://a.klaviyo.com',
  options: {
    // 使用函数动态获取请求头
    beforeFetch({ options }) {
      // 动态设置授权头
      options.headers = {
        ...options.headers,
          'accept': 'application/vnd.api+json',
          'revision': '2025-10-15',
          'Content-Type': 'application/vnd.api+json'
      }
      return { options }
    },
    afterFetch(ctx) {
      console.log('ctx: ', ctx);
      return ctx || {};
    },
  },
  fetchOptions: {
    mode: 'cors',
  },
});

export const useAEMHtmlFetch = createFetch({
  baseUrl: aemPath
});